"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyTags = exports.Encoding = exports.PubKeyType = exports.DIDAttribute = void 0;
/**
 * Currently, there are three types of DID Attributes, this can be potentially extended
 */
var DIDAttribute;
(function (DIDAttribute) {
    DIDAttribute["PublicKey"] = "pub";
    DIDAttribute["Authenticate"] = "auth";
    DIDAttribute["ServicePoint"] = "svc";
})(DIDAttribute = exports.DIDAttribute || (exports.DIDAttribute = {}));
/**
 * The two main types of public keys are, in turn, verification key and signature authentication key
 */
var PubKeyType;
(function (PubKeyType) {
    PubKeyType["SignatureAuthentication2018"] = "sigAuth";
    PubKeyType["VerificationKey2018"] = "veriKey";
})(PubKeyType = exports.PubKeyType || (exports.PubKeyType = {}));
/**
 * Encoding specifies the format in which the public key is store
 */
var Encoding;
(function (Encoding) {
    Encoding["HEX"] = "hex";
    Encoding["BASE64"] = "base64";
    Encoding["PEM"] = "pem";
})(Encoding = exports.Encoding || (exports.Encoding = {}));
/**
 * KeyTags specifies the tags associated with different purposes of the keys
 */
var KeyTags;
(function (KeyTags) {
    KeyTags["OWNER"] = "key-owner";
})(KeyTags = exports.KeyTags || (exports.KeyTags = {}));
//# sourceMappingURL=operator.js.map